/**
 * Image Model Configuration Index
 * Centralized export for all image generation models
 */

import dallE2 from "./dall-e-2.json";
import dallE3 from "./dall-e-3.json";
import flux1Dev from "./flux-1-dev.json";
import flux1Pro from "./flux-1-pro.json";
import flux1Schnell from "./flux-1-schnell.json";
import fluxProKontext from "./flux-pro-kontext.json";
import gemini25Flash from "./gemini-2-5-flash.json";
import gptImage1 from "./gpt-image-1.json";
import grok2Image from "./grok-2-image.json";
import imagen3 from "./imagen-3.json";
import imagen4 from "./imagen-4.json";
import imagen4Ultra from "./imagen-4-ultra.json";
import imagen4Fast from "./imagen-4-fast.json";
import nanoBananaPro from "./nano-banana-pro.json";
import qwen2Image from "./qwen-2-image.json";
import qwenImage from "./qwen-image.json";
import seedreamV4Edit from "./seedream-v4-edit.json";

export const imageModels = {
  "gpt-image-1": gptImage1,
  "dall-e-3": dallE3,
  "dall-e-2": dallE2,
  "qwen-image": qwenImage,
  "qwen-2-image": qwen2Image,
  "flux-1-dev": flux1Dev,
  "flux-1-schnell": flux1Schnell,
  "flux-1-pro": flux1Pro,
  "flux-pro-kontext": fluxProKontext,
  "gemini-2.5-flash": gemini25Flash,
  "nano-banana-pro": nanoBananaPro,
  "imagen-3.0-generate-002": imagen3,
  "imagen-4.0-generate-001": imagen4,
  "imagen-4.0-ultra-generate-001": imagen4Ultra,
  "imagen-4.0-fast-generate-001": imagen4Fast,
  "grok-2-image": grok2Image,
  "seedream-v4-edit": seedreamV4Edit,
};

export const getImageModel = (modelId) => {
  return imageModels[modelId];
};

export const getImageModelsByProvider = (provider) => {
  return Object.values(imageModels).filter(
    (model) => model.provider === provider
  );
};

export const getAllImageModels = () => {
  return Object.values(imageModels);
};

export const getImageModelCapabilities = (modelId) => {
  return imageModels[modelId]?.capabilities || {};
};

export const getEditableImageModels = () => {
  return Object.values(imageModels).filter(
    (model) => model.capabilities.editing === true
  );
};

export default imageModels;
